/* global deletePayrateUrl fetchPayrateUrl updatePayrateUrl payrate payratesUrl */

import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Modal } from 'flowbite';

import PayrateModal from './PayrateModal';

import { formatFigure, formatToFixedMoneyWithLocale } from 'Helpers/formatService';
import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ContentList from 'CommonComponents/ContentList';
import ContentListItem from 'CommonComponents/ContentListItem';
import SimpleConfirmationModal from 'CommonComponents/SimpleConfirmationModal';

import useApiRequest from 'Hooks/useApiRequest';
import { useToast } from 'Hooks/useToast';

export default function WorkforcePayrate(props) {
    const [payrate, setPayrate] = useState(props.payrate);

    useEffect(() => {
        fetchPayrate();
        updatePayrateModalRef && setUpdatePayrateModalElement(new Modal(updatePayrateModalRef.current, modalOptions(false)));
        deletePayrateModalRef && setDeletePayrateModalElement(new Modal(deletePayrateModalRef.current, modalOptions(false)));
    }, []);

    const toast = useToast();

    const [updatePayrateModalElement, setUpdatePayrateModalElement] = useState(null);
    const [deletePayrateModalElement, setDeletePayrateModalElement] = useState(null);

    const updatePayrateModalRef = useRef();
    const deletePayrateModalRef = useRef();

    const fetchRequest = useApiRequest({ url: props.fetchUrl });
    const deleteRequest = useApiRequest({ url: props.deleteUrl });

    const fetchPayrate = () => {
        fetchRequest.get().then((res) => {
            const { data } = res;
            setPayrate(data.payrate);
        });
    };

    const showUpdatePayrateModal = () => {
        updatePayrateModalElement && updatePayrateModalElement.show();
    };

    const showDeleteModal = () => {
        deletePayrateModalElement && deletePayrateModalElement.show();
    };

    const closeModal = () => {
        updatePayrateModalElement && updatePayrateModalElement.hide();
        deletePayrateModalElement && deletePayrateModalElement.hide();
    };

    const removePayrate = () => {
        deleteRequest
            .delete({})
            .then((response) => {
                toast.success('Payrate successfully removed');
                closeModal();
                window.location.href = props.payratesUrl;
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || $t('Something went wrong while deleting the payrate'));
            });
    };

    return (
        <>
            {!!payrate && (
                <>
                    <div className="tw-space-y-2">
                        <div className="tw-grid tw-grid-cols-1 tw-gap-2">
                            <div>
                                <div className="tw-px-6 tw-py-6.5 tw-rounded-lg tw-bg-white tw-shadow-primary">
                                    <div className="tw-flex tw-justify-between tw-items-start">
                                        <h3 className="table__header">{$t('Info')}</h3>
                                    </div>
                                    <div className="tw-flex tw-gap-x-1.5 tw-justify-between">
                                        <ContentList>
                                            <ContentListItem title={$t('Name')} classNames="tw-items-center">
                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                    <span className="tw-px-3 tw-font-bold">{payrate.name}</span>
                                                </div>
                                            </ContentListItem>
                                            <ContentListItem title={$t('Min')} classNames="tw-items-center">
                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                    <span className="tw-px-3 tw-font-bold">{formatToFixedMoneyWithLocale(payrate.min)}</span>
                                                </div>
                                            </ContentListItem>
                                            <ContentListItem title={$t('Max')} classNames="tw-items-center">
                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                    <span className="tw-px-3 tw-font-bold">{formatToFixedMoneyWithLocale(payrate.max)}</span>
                                                </div>
                                            </ContentListItem>
                                            <ContentListItem title={$t('Average')} classNames="tw-items-center">
                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                    <span className="tw-px-3 tw-font-bold">
                                                        {formatToFixedMoneyWithLocale((payrate.max + payrate.min) / 2)}
                                                    </span>
                                                </div>
                                            </ContentListItem>
                                        </ContentList>

                                        <div className="tw-self-end tw-mt-auto">
                                            <Button variant="secondary" onClick={() => showUpdatePayrateModal()}>
                                                {$t('Edit')}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="tw-space-y-2 tw-my-3">
                        <div className="tw-grid tw-grid-cols-1 tw-gap-2">
                            <div>
                                <div className="tw-px-6 tw-py-6.5 tw-rounded-lg tw-bg-white tw-shadow-primary">
                                    <div className="tw-mt-6">
                                        <h3 className="tw-font-bold tw-text-base tw-mb-2">{$t('Percentages by Year')}</h3>
                                        <table className="tw-border-collapse tw-border tw-border-gray-300 tw-w-full">
                                            <thead>
                                                <tr className="tw-bg-gray-100">
                                                    <th className="tw-border tw-border-gray-300 tw-px-4 tw-py-2">{$t('Year')}</th>
                                                    <th className="tw-border tw-border-gray-300 tw-px-4 tw-py-2">{$t('Inflation (%)')}</th>
                                                    <th className="tw-border tw-border-gray-300 tw-px-4 tw-py-2">{$t('Bonus (%)')}</th>
                                                    <th className="tw-border tw-border-gray-300 tw-px-4 tw-py-2">{$t('On Costs (%)')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.keys(payrate.percentage.inflation).map((year) => (
                                                    <tr key={year}>
                                                        <td className="tw-border tw-border-gray-300 px-4 tw-py-2 tw-text-center">{year}</td>
                                                        <td className="tw-border tw-border-gray-300 tw-px-4 tw-py-2">
                                                            <span>
                                                                {formatFigure(payrate.percentage.inflation[year], formatToFixedMoneyWithLocale, {
                                                                    precision: 1,
                                                                })}
                                                            </span>
                                                        </td>
                                                        <td className="tw-border tw-border-gray-300 tw-px-4 tw-py-2">
                                                            <span>
                                                                {formatFigure(payrate.percentage.bonus[year], formatToFixedMoneyWithLocale, { precision: 1 })}
                                                            </span>
                                                        </td>
                                                        <td className="tw-border tw-border-gray-300 tw-px-4 tw-py-2">
                                                            <span>
                                                                {formatFigure(payrate.percentage.onCosts[year], formatToFixedMoneyWithLocale, { precision: 1 })}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-self-end tw-mt-auto">
                                <Button variant="danger" onClick={() => showDeleteModal()}>
                                    {$t('Delete')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <PayrateModal
                modalId="save-payrate-modal"
                modalRef={updatePayrateModalRef}
                modalElement={updatePayrateModalElement}
                saveUrl={props.updateUrl}
                defaultPercentage={payrate.percentage}
                onClose={closeModal}
                onCancel={closeModal}
                payrate={payrate}
                onSuccess={() => {
                    closeModal();
                    fetchPayrate();
                }}
            />

            <SimpleConfirmationModal
                closeHandler={() => closeModal()}
                allowAction={true}
                modalId={'delete-payrate-modal'}
                modalRef={deletePayrateModalRef}
                modalElement={deletePayrateModalElement}
                confirmationMsg={$t('Are you sure you want to delete this payrate?')}
                title={$t('Delete Payrate')}
                cancelButtonText={$t('Close')}
                primaryButtonText={$t('Delete')}
                successHandler={() => {
                    removePayrate();
                }}
            />
        </>
    );
}

if (document.getElementById('ShowPayrate')) {
    var rootEl = document.getElementById('ShowPayrate');
    ReactDOM.render(
        <App>
            <WorkforcePayrate
                fetchUrl={fetchPayrateUrl}
                updateUrl={updatePayrateUrl}
                deleteUrl={deletePayrateUrl}
                payrate={payrate}
                payratesUrl={payratesUrl}
            />
        </App>,
        rootEl,
    );
}
